import './nav-tabs.scss';

import { Link } from '../../atoms/link/link';

export type LinkPlaceholder = {
  id: string;
  title: string;
  path: string;
};

export type NavTabsProps = {
  links: LinkPlaceholder[];
};

/**
 * TODO: accessibility considerations we need to have in mind for these tertiary navs
 */

export const NavTabs: React.FC<NavTabsProps> = ({ links }) => {
  if (!links || links.length === 0) {
    return null;
  }

  return (
    <nav className="NavTabs relative w-100 overflow-hidden mb-comfy-xl">
      <div className="NavTabs__scrollcontainer overflow-x-auto">
        <div className="NavTabs__list flex gap-comfy-md" role="tablist">
          {links.map((link) => {
            return (
              <Link
                key={link.id}
                href={link.path}
                className="NavTabs__tab label-potent label-lg pr-snug-md pb-comfy-xs pl-snug-md flex-shrink-0"
              >
                {link.title}
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
};
